import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate  } from "react-router-dom";
import * as api from "../../../services/apiService";
import Toast from "react-bootstrap/Toast";
import "quill/dist/quill.snow.css";
import "./SigningPage.scss";


function SigningPage() {
  const { ProblemId } = useParams();

  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [organization, setOrganization] = useState("");
  const [user, setUser] = useState("");
  const [dateAdded, setDateAdded] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [wantsNewsletter, setWantsNewsletter] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchProblem() {
      try {
        const response = await api.getComplaint(ProblemId);
        const data = await response.json();

        setText(data.text || "");
        setTitle(data.title || "");
        setImageLink(data.imageLink || "");
        setOrganization(data.organization || "");
        setUser(data.user || "");
        setDateAdded(data.dateAdded.split("T")[0]);
      } catch (error) {
        alert("Could not fetch complaint data: " + error);
      }
    }

    fetchProblem();
  }, [ProblemId]);

  const handleSign = async () => {
      const request = {
        complaintId: ProblemId,
        name: name,
        email: email,
        phone: phoneNumber,
        subscribeNewsletter: wantsNewsletter,
      }

      try {
        await api.signComplaint(request);
        
        // 1. Set the success message and show the popup
        setToastMessage("Petiția a fost semnată cu succes!");
        setShowToast(true);

        // 2. Wait for 2.5 seconds (2500 ms) so the user can read the popup, then redirect
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 2500);

      } catch (error) {
        // Optional: Show an error popup if the API fails
        console.error("Error signing complaint:", error);
        setToastMessage("A apărut o eroare. Vă rugăm să încercați din nou.");
        setShowToast(true);
      }
    };

  const handleNewsletterChange = (e) => {
    setWantsNewsletter(e.target.checked);
    // TODO: salvează alegerea utilizatorului dacă e nevoie
  };

  return (
    <div className="container py-4">
      <h2 className="signing-page-title">{title}</h2>
  
      <article className="signing-page-article">
      <div className="signing-page-info">
        <p className="centered">{dateAdded}</p>
        <p className="centered">{user} - {organization}</p>
      </div>

        <div className="signing-page-image-container">
          <img
            src={api.baseUrl + imageLink}
            className="signing-page-image"
            alt=""
          />
        </div>

        <div
          className="signing-page-text ql-editor"
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>
      </article>

  
      <h2 className="signing-form-title">Formular Semnare</h2>
  
      <div className="signing-form-group">
        <label>Nume şi Prenume</label>
        <input
          type="text"
          value={name}
          name="name"
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="signing-form-group">
        <label>Email</label>
        <input
          type="email"
          value={email}
          name="email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="signing-form-group">
        <label>Număr de Telefon (opţional)</label>
        <input
          type="tel"
          value={phoneNumber}
          name="phone"
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      </div>

      <div className="signing-form-group checkbox-group">
        <input
          type="checkbox"
          id="newsletter"
          checked={wantsNewsletter}
          onChange={handleNewsletterChange}
        />
        <label htmlFor="newsletter">Doresc să primesc vești despre viitoarele petiții</label>
      </div>
  
      <div className="buttons-container">
        <button onClick={handleSign} className="sign-button">
          Semnează
        </button>
    
        <Link to={"/"} className="link-button">
          <button className="back-button">
            Înapoi
          </button>
        </Link>
      </div>
  
      <div className="toast-container-fixed">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={5000}
          autohide
          className="custom-toast"
          animation={false}
        >
          <Toast.Header>
            <span className="me-auto">Notificare</span>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </div>
    </div>
  );
}

export default SigningPage;
